const Observer = function(options) {
    let threshold = []
    let n = 0

    while (n < 1) {
        n += 0.01
        threshold.push(parseFloat(n.toFixed(2)))
    }

    let observerOptions = {
        // root: document.querySelector('body'),
        rootMargin: '0px',
        threshold: threshold
    }

    let observer = new IntersectionObserver(options.callback, observerOptions);
    return observer
}

module.exports = Observer